import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "filter-value-form",
  templateUrl: "./filter-value-form.component.html",
  styleUrls: ["./filter-value-form.component.scss"],
})
export class FilterValueFormComponent {
  @Input() form: FormGroup;

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/filter-value-form/filter-value-form.component.ts